import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=4da53257&"
import script from "./projectView.vue?vue&type=script&lang=js&"
export * from "./projectView.vue?vue&type=script&lang=js&"
import style0 from "./projectView.vue?vue&type=style&index=0&id=4da53257&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports